import { JobAdmition } from "./JobAdmition";
import { BaseSendMessageModel } from "./MessageModel";

export interface JobRequest {

	Id: number,
	CompanyName: string,
	CompanyLogoId: any,
	CategoryId: number,
	Category: string,
	Description: string,
	Budget: number,
	Location: string,
	Profession: string;
	LocationCoordinate: {
		Geography: {
			CoordinateSystemId: number,
			WellKnownText: string,
			WellKnownBinary: string
		}
	},
	CreatedByUserId: string,
	CreatedByUser: string,
	CreatedDateUtc,
	Status: number,
	StatusText: string,
	Admitions: JobAdmition[],
	Connected: [
		{
			Id: number,
			UserId: string,
			UserPicture: any,
			CompanyPicture: any,
			FullName: string,
			CompanyName: string,
			EmailAddress: string,
			PhoneNumber: string,
			Experience: string,
			References: string,
			Images: [
				any
			],
			Website: string,
			CreatedDateUtc: any,
			Connected: boolean
		}
	],
}

export class CreateJobRequestModel extends BaseSendMessageModel {
	companyName: string;
	description: string;
	category: string;
	location: string;
	status: number;
	statusText: string;
	budget: number;
	categoryId: number;
	profession: string;
}
export class EditJobRequestModel extends CreateJobRequestModel {
	public Id: number;
	constructor(item?: JobRequest) {
		super();
		this.Id = item && item.Id;
		this.companyName = item && item.CompanyName;
		this.description = item && item.Description;
		this.category = item && item.Category;
		this.location = item && item.Location;
		this.status = item && item.Status;
		this.statusText = item && item.StatusText;
		this.budget = item && item.Budget;
		this.categoryId = item && item.CategoryId;
		this.profession = item && item.Profession;
	}
}



// WEBPACK FOOTER //
// ./src/app/models/inModels/jobRequest.ts